<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  watch: {
    $route(val) {
      this.$store.commit('SET_CURRENT_ROUTE', val)
    }
  }
}
</script>
